import { render } from "./SliderItem.vue?vue&type=template&id=42ab8b45&scoped=true"
import script from "./SliderItem.vue?vue&type=script&lang=js"
export * from "./SliderItem.vue?vue&type=script&lang=js"

import "./SliderItem.vue?vue&type=style&index=0&id=42ab8b45&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ab8b45"]])

export default __exports__